import { useEffect, useState } from "react";

import {
  CARD_BORDER_RADIUS,
  CARD_INSET_HORIZONTAL,
  CARD_INSET_VERTICAL,
  CARD_INSTITUTION_LOGO_MAX_HEIGHT,
  CARD_INSTITUTION_LOGO_WIDTH,
  CARD_NETWORK_LOGO_INSET_BOTTOM,
  CARD_NETWORK_LOGO_INSET_RIGHT,
  CARD_NETWORK_LOGO_WIDTH,
  CARD_PREVIEW_HEIGHT,
  CARD_PREVIEW_WIDTH,
  DEFAULT_CARDHOLDER_PREVIEW_NAME,
} from "../cardProgramDesignConstants";

import { CardDesignPreviewBack } from "./CardDesignPreviewBack";
import { CardMastercardHologramLogo } from "./CardMastercardHologramLogo";

const CardDesignPreviewFront = ({
  customLogo,
  frontArt = null,
}) => (
  <>
    {frontArt ? (
      <img
        src={frontArt}
        alt=""
        className="absolute inset-0 h-full w-full object-cover"
        style={{ borderRadius: CARD_BORDER_RADIUS }}
        aria-hidden
      />
    ) : null}

    {customLogo ? (
      <div
        className="absolute"
        style={{
          left: CARD_INSET_HORIZONTAL,
          top: CARD_INSET_VERTICAL,
          zIndex: 1,
        }}
      >
        <img
          src={customLogo}
          alt=""
          className="card-design-preview__brand-logo"
          style={{
            width: CARD_INSTITUTION_LOGO_WIDTH,
            maxHeight: CARD_INSTITUTION_LOGO_MAX_HEIGHT,
            objectFit: "contain",
            objectPosition: "left",
            display: "block",
          }}
        />
      </div>
    ) : null}

    <div
      className="absolute"
      style={{
        right: CARD_NETWORK_LOGO_INSET_RIGHT,
        bottom: CARD_NETWORK_LOGO_INSET_BOTTOM,
        zIndex: 1,
      }}
    >
      <CardMastercardHologramLogo
        width={CARD_NETWORK_LOGO_WIDTH}
        variant="monochrome"
      />
    </div>
  </>
);

export const CardDesignPreview = ({
  backgroundColor = "#000000",
  cardholderName = DEFAULT_CARDHOLDER_PREVIEW_NAME,
  customLogo = null,
  frontArt = null,
  backArt = null,
  mastercardVariant: _mastercardVariant = "black",
  network = "mastercard",
  side = "front",
  className = "",
  website,
  phoneMetropolitan,
  phoneOther,
  cardNumberPreview,
  expiryPreview,
  cvcPreview,
}) => {
  const [fading, setFading] = useState(false);
  const [displaySide, setDisplaySide] = useState(side);

  useEffect(() => {
    if (side === displaySide) {
      return undefined;
    }

    setFading(true);
    const timer = window.setTimeout(() => {
      setDisplaySide(side);
      setFading(false);
    }, 120);

    return () => window.clearTimeout(timer);
  }, [side, displaySide]);

  return (
    <div className={`card-design-preview-stage ${className}`.trim()}>
      <div
        className={`card-design-preview__card ${fading ? "card-design-preview__card--fading" : ""}`}
        style={{
          width: CARD_PREVIEW_WIDTH,
          height: CARD_PREVIEW_HEIGHT,
          borderRadius: CARD_BORDER_RADIUS,
          backgroundColor: displaySide === "front" ? backgroundColor || "#000000" : "transparent",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {displaySide === "front" ? (
          <CardDesignPreviewFront
            customLogo={customLogo}
            frontArt={frontArt}
          />
        ) : (
          <CardDesignPreviewBack
            website={website}
            phoneMetropolitan={phoneMetropolitan}
            phoneOther={phoneOther}
            cardNumberPreview={cardNumberPreview}
            expiryPreview={expiryPreview}
            cvcPreview={cvcPreview}
            cardholderName={cardholderName}
            backArt={backArt}
          />
        )}
      </div>
    </div>
  );
};
